import queryString from 'query-string';
import { Form, Button, Upload, Icon, Tag } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getTicketDetail, getTickets, getTitles, TicketAddAttachment, TicketAddMessage } from '../../Actions/HelpAction';
import { fileToBase64 } from '../../helpers/helpers';
import { uploadFile } from '../../Actions/FileManagerAction';
import { showError } from '../../Actions/VisualDataAction';
import { Link, withRouter } from "react-router-dom";
import moment from 'moment-jalaali';
import TicketFileItem from './TicketFileItem';
import { setUnreadTickets } from '../../Actions/UserAction';

const TicketDetail = props => {

    const Dictionary = useSelector(state => state.VisualData.Dictionary);
    const LAN = useSelector(state => state.VisualData.LAN);
    const dispatch = useDispatch();

    const { getFieldDecorator } = props.form;

    const [data, setData] = useState();
    const isItoursIr = process.env.REACT_APP_SERVER_CULTURE === "IR";

    useEffect(()=>{
        window?.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
    },[]);
    
    useEffect(() => {
        if (isItoursIr) {
            moment.loadPersian({
                dialect: "persian-modern",
                usePersianDigits: false,
            });
        }
    }, [isItoursIr]);

    const localStorageToken = localStorage.getItem("userToken");

    const ticketId = queryString.parse(props.location.search)?.id;
    useEffect(() => {

        let timeout;


        const fetchUnreadTickets = async (token) => {
            const response = await getTickets({
                token: token,
                MaxResultCount: 5,
                SkipCount: 0,
                notRead: true
            });
    
            if (response?.data?.result?.totalCount) {
                dispatch(setUnreadTickets(!!response.data.result.totalCount))
            } else {
                dispatch(setUnreadTickets(false))
            }
        }
        

        const fetchDetail = async (id, token) => {
            const response = await getTicketDetail({
                id: id,
                token: token
            },
                LAN === "IR" ? "fa-IR" : "en-US"
            );
            if (response?.data?.result) {
                setData(response.data.result);
                fetchUnreadTickets(token);
            }
        }
        if (localStorageToken && ticketId) {
            timeout = setTimeout(() => { fetchDetail(ticketId, localStorageToken) }, 100);
        }

        return (() => { clearTimeout(timeout) })

    }, [ticketId, localStorageToken, LAN]);

    const [loading, setLoading] = useState(false);
    const [openSuccessModal, setOpenSuccessModal] = useState(false);

    const [types, setTypes] = useState();

    const [fileList, setFileList] = useState([]);

    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'docx', 'xlsx', 'txt'];
    const acceptTypes = allowedExtensions.map((ext) => `.${ext}`).join(','); // Convert to ".pdf,.png,.jpg,..."

    const handleAttachments = async () => {
        const attachments = fileList.filter((f) => f.originFileObj).map((item) => item.originFileObj) || [];
        if (!attachments.length) return undefined;

        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB limit
        const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'docx', 'xlsx', 'txt'];

        const uploadPromises = attachments.map(async (attachment) => {
            if (!attachment.name || !attachment.size) {
                console.warn('Skipping file: Missing name or size');
                return Promise.resolve(null);
            }

            const trimmedName = attachment.name.trim();
            const lastDotIndex = trimmedName.lastIndexOf('.');

            // Extract the extension and normalize it to lowercase
            const fileExtension = lastDotIndex !== -1 ? trimmedName.substring(lastDotIndex + 1).toLowerCase() : '';

            // 🛑 Prevent hidden/system files (starting with a dot)
            if (trimmedName.startsWith('.')) {
                console.warn(`Skipping file: Hidden or system file (${trimmedName})`);
                return Promise.resolve(null);
            }

            // 🛑 Validate against allowed file extensions
            if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
                console.warn(`Skipping file: Unsupported file type (${fileExtension})`);
                return Promise.resolve(null);
            }

            // 🛑 Prevent empty files
            if (attachment.size === 0) {
                console.warn(`Skipping file: Empty file (${trimmedName})`);
                return Promise.resolve(null);
            }

            // 🛑 Prevent oversized files
            if (attachment.size > MAX_FILE_SIZE) {
                console.warn(`Skipping file: File size exceeds limit (${trimmedName}, ${attachment.size} bytes)`);
                return Promise.resolve(null);
            }

            const fileName = `${crypto.randomUUID()}.${fileExtension}`; // Generate safe filename

            const base64 = await fileToBase64(attachment);

            return uploadFile({
                fileName,
                file: base64.base64Content,
                type: 'Tickets',
            },"IR",localStorageToken)

        });

        const results = await Promise.all(uploadPromises);

        const attachmentIdList = results
            .filter((response) => response?.data?.result)
            .map((response) => ({
                fileUniqKey: response?.data?.result?.uniqKey,
                filePath: response?.data?.result?.uniqKey
            }));

        if (attachmentIdList.length !== attachments.length) {
            throw new Error('Failed to upload all attachments');
        }

        return attachmentIdList;

    }


    const SubmitHandler = async (e) => {

        e.preventDefault();

        props.form.validateFields(async (err, values) => {

            if (!err) {
                setLoading(true);
                try {
                    const attachmentIdList = await handleAttachments();

                    const params = {
                        id: +ticketId,
                        message: { message: values.Comment }
                    }

                    const response = await TicketAddMessage(params, localStorageToken, LAN === "IR" ? "fa-IR" : "en-US");

                    if(attachmentIdList?.length){
                        attachmentIdList.forEach(async attachment => {
                            await TicketAddAttachment(
                                {
                                    id: +ticketId,
                                    attachment: attachment
                                },
                                localStorageToken,
                                LAN === "IR" ? "fa-IR" : "en-US"
                            );
                        })

                    }


                    if (response?.error) {
                        dispatch(
                            showError({
                                visibility: true,
                                content: response.error.message || "Internal Error,Please refresh the page",
                                closable: true
                            })
                        )
                    }

                    if (response?.data?.success) {
                        setOpenSuccessModal(true);
                    }

                    setLoading(false);

                } catch (error) {
                    console.error(error);
                }
            }
        });

    }

    const backToList = () => {
        props.history.push(`/profile?mode=tickets`);
    }

    const language = LAN === "IR" ? "fa-IR" : "en-US";

    useEffect(() => {
        const fetchTitles = async (t, lang) => {
            const response = await getTitles(t, lang);
            if (response.data?.result?.items) {
                setTypes(response.data.result.items);
            }
        }

        if (localStorageToken && language) {
            fetchTitles(localStorageToken, language);
        }

    }, [localStorageToken, language]);

    const typeTitle = id => {
        return (types?.find(item => item.id === id)?.title || "")
    }

    const getColor = (status) => {
        switch (status) {
            case 'Open':
                return '#2196f3';
            case 'InProgress':
                return '#ffba5b';
            case 'Answered':
                return '#93c053';
            case 'Closed':
                return '#555';
            default:
                return 'gray';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'Open':
                return Dictionary.Open;
            case 'InProgress':
                return Dictionary.InProgress;
            case 'Answered':
                return Dictionary.Answered;
            case 'Closed':
                return Dictionary.Closed;
            default:
                return status;
        }
    }

    const statusElement = data ? <Tag className='font-16 pt-4' color={getColor(data.status)}> {getStatusText(data.status)} </Tag> : null;

    return (
        <div className="section-vertical-padding">

            {openSuccessModal && (
                <div className="itours-modal visible" >
                    <div className="modal-overlay" onClick={() => { setOpenSuccessModal(false) }} />
                    <div className="modal-inner small-width">
                        <div className="modal-main text-center">
                            <div className="image text-center margin-bottom margin-top">
                                <span className={`icon-xlarge itours-icon check-green`} />
                            </div>
                            <p className="margin-bottom-large">
                                {Dictionary.YourMessageSavedSuccessfully}.
                            </p>
                            <button
                                type="button"
                                className="button blue-btn margin-bottom"
                                onClick={backToList}
                            >
                                {Dictionary.ok}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="page-container">
                <div className='ticket-information'>
                    <div>
                        <h2 className="medium-title">  {Dictionary.Title} : {data?.title || typeTitle(data?.titleId)} </h2>
                        <div className='bold'> {Dictionary.ReservationNumber} : {data?.reserveId} </div>
                        <div className='bold margin-bottom'> {Dictionary.TrackingID} : {data?.id} </div>
                    </div>

                    {data ? <div className='text-end font-13'>
                        <div className=''> {Dictionary.status} :  {statusElement} </div>
                        <div>  {Dictionary.CreatedBy} : {data.userDisplayName || "---"}</div>
                        <div>  {Dictionary.DateCreated} : {moment.utc(data.creationTime).local().format(LAN === "IR" ? "jYYYY/jMM/jDD - HH:mm" : "YYYY/MM/DD - HH:mm")} </div>
                    </div> : null}

                </div>

                <div className='ticket-messages margin-bottom-large'>
                    {data?.messages?.map(message => (
                        <div className='margin-bottom ticket-message-item' key={message.id}>
                            <header className='message-header'>
                                {message.isFromOperator?(
                                    <span className='itours-icon support-circle icon-large grayscale' />
                                ):(
                                    <span className='itours-icon user-circle icon-large grayscale' />
                                )}
                                <div>
                                    <div className='bold font-15'> {message.isFromOperator ? Dictionary.Support : message.userDisplayName} </div>
                                    <span className='font-13 gray' > {moment.utc(message.creationTime).local().format(LAN === "IR" ? "jD jMMMM jYYYY - HH:mm" : "D MMMM YYYY - HH:mm")} </span>
                                </div>
                            </header>
                            <div className='message-body'>
                                {message.message}
                            </div>
                        </div>
                    ))}

                </div>

                {data?.attachments?.length > 0 && (

                    <div className="ticketing-files-wrapper">
                        {data.attachments?.map((item) => (
                            <TicketFileItem key={item.id} item={item} />
                        ))}
                    </div>

                )}

                {data?.status === "Closed" ? (
                    <div>
                        {Dictionary.ThisTicketIsClosedAndCannotBeAnswered}.
                        <Link to="/tickets/create" className="margin-start"> {Dictionary.CreateNewTicket} </Link>
                    </div>
                ) : (
                    <Form onSubmit={SubmitHandler} className='margin-bottom-large' >

                        <p className="margin-bottom" > {Dictionary.ToSubmitAReplyToThisTicketUseTheFormBelow}. </p>

                        <Form.Item className="form-group">
                            {getFieldDecorator('Comment', {
                                rules: [{ required: true, message: Dictionary.thisFieldIsRequired }],
                            })(
                                <textarea placeholder={Dictionary.messageText} className="full-width form-input hotel-comment-textarea"></textarea>
                            )}
                        </Form.Item>

                        <br />
                        <Upload
                            className='upload-files'
                            fileList={fileList}
                            multiple
                            beforeUpload={() => false}
                            onChange={data => { setFileList(data.fileList); }}
                            accept={acceptTypes}
                        >
                            <Button>
                                <Icon type="upload" /> {Dictionary.UploadFile}
                            </Button>
                        </Upload>

                        <button type='submit' className='button blue-btn margin-top-large'> {Dictionary.send}
                            {loading && <span className="loading-inline-circle margin-start-light" />}
                        </button>
                    </Form>
                )}

            </div>
        </div>
    )
}

const TicketDetailForm = Form.create({ name: 'newTicket' })(TicketDetail);

export default withRouter(TicketDetailForm);